import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

export interface ImagensStatus {
  capa: boolean;
  padrao: boolean;
  pedido: boolean;
  delivery: boolean;
}

export const useProdutoImagens = (produtoId: string | undefined) => {
  const qc = useQueryClient();
  const numId = produtoId ? Number(produtoId) : undefined;
  const key = ["produto-imagens", numId];
  const base = `/api/produtos/${numId}/imagens`;

  const { data: status } = useQuery({
    queryKey: key,
    queryFn: async () => (await apiClient.get<ImagensStatus>(base)).data,
    enabled: !!numId,
  });

  const invalidar = (slot: string) => {
    qc.invalidateQueries({ queryKey: key });
    qc.invalidateQueries({ queryKey: ["produto-imagem-blob", numId, slot] });
  };

  const uploadMutation = useMutation({
    mutationFn: async ({ slot, file }: { slot: string; file: File }) => {
      const fd = new FormData();
      fd.append("arquivo", file);
      await apiClient.post(`${base}/${slot}`, fd);
    },
    onSuccess: (_d, v) => { invalidar(v.slot); toast.success("Foto enviada!"); },
    onError: (e: Error) => toast.error(`Erro ao enviar foto: ${e.message}`),
  });

  const removeMutation = useMutation({
    mutationFn: async (slot: string) => { await apiClient.delete(`${base}/${slot}`); },
    onSuccess: (_d, slot) => { invalidar(slot); toast.success("Foto removida!"); },
    onError: (e: Error) => toast.error(`Erro ao remover foto: ${e.message}`),
  });

  return {
    status,
    upload: (slot: string, file: File) => uploadMutation.mutate({ slot, file }),
    remove: (slot: string) => removeMutation.mutate(slot),
  };
};
